import logoLight from "Assets/logo.svg";
import logoDark from "Assets/logo-blue.svg";
import styles from "Styles/Logo.module.css";
import { useVisualContext } from "Contexts/VisualContext";
import useSegment from "Hooks/useSegment";
import { useState, useEffect } from "react";
import { useDebouncedCallback } from "use-debounce";
import { motion } from "framer-motion";
import classNames from "classnames";

export default function Logo({ large }) {
  const { backgroundStyle } = useVisualContext();
  const segment = useSegment();
  const [yPosition, setYPosition] = useState(0);

  const handleScrollY = useDebouncedCallback((e) => {
    if (segment !== "complete") return;
    setYPosition(e.target.scrollTop);
  }, 100);

  useEffect(() => {
    if (segment !== "complete") return;

    window.addEventListener("scroll", handleScrollY, { capture: true });

    return () => {
      window.removeEventListener("scroll", handleScrollY);
    };
  }, [yPosition, handleScrollY, segment]);

  const logoVariant = {
    initial: {
      opacity: 1,
      scale: 1,
    },
    animate: {
      opacity: 0,
      scale: 0,
      transition: {
        duration: 0.3,
        ease: "easeInOut",
      },
    },
  };

  return (
    <motion.div
      variants={logoVariant}
      initial="initial"
      animate={yPosition > 0 ? "animate" : "initial"}
      whileHover={{
        scale: 1.02,
        transition: {
          type: "spring",
          stiffness: 300,
        },
      }}
      className={classNames(styles.logoWrapper, {
        [styles.logoLarge]: large || backgroundStyle === "fullwidth",
      })}
    >
      <a
        href="https://www.hububble.co/"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src={
            backgroundStyle === "inverted" || backgroundStyle === "hidden"
              ? logoDark
              : logoLight
          }
          alt="logo"
          className={styles.logo}
        />
      </a>
    </motion.div>
  );
}
